export default function getAdCompleted(state, ownProps) {
  return state.ads.adCompleted;
}
